var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("COM_HeaderNav", { attrs: { mode: "onePageAdv" } }),
      _c("div", { staticClass: "bk_toolbar_fixed-top" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-info",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$router.back()
              }
            }
          },
          [_c("i", { staticClass: "fa fa-arrow-left" }), _vm._v("回上一頁")]
        ),
        _vm._m(0),
        _vm._m(1)
      ]),
      _c("iframe", { attrs: { id: "myIframe" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "btn btn-primary", attrs: { href: "#" } }, [
      _c("i", { staticClass: "fa fa-clone" }),
      _vm._v(" 複製")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "btn btn-primary", attrs: { href: "#" } }, [
      _c("i", { staticClass: "fa fa-share-alt" }),
      _vm._v("分享 ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }